module.exports = __webpack_public_path__ + "static/media/empty-state-documents-v1.a5d45550.svg";